<template>
  <div class="login">
    <form>
     <div class="from-item">
        <span>用户名 </span>
        <input v-model="name" type="text" />
      </div>
      <div class="from-item">
        <span>密&nbsp;&nbsp;&nbsp;码 </span>
        <input v-model="password" type="password" />
      </div>
      <div class="from-item record" @click="handleLogin">
        登录
      </div>
    </form>
    <div class="footer" v-if="wx" >
      <img src="../assets/icons/login.png">
      <span>微信登录</span>
    </div>
    <div class="footer" v-else>
      <img src="../assets/icons/login.png">
      <span>用户登录</span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
export default {
  name: "Dialog",
  data() {
    return {
      wx: false,
      name: '',
      password: '',
    };
  },
  computed: {
    ...mapGetters(['token']),
  },
  created() {
    if(localStorage.user) {
     const { pwd, userid } = JSON.parse(localStorage.user);
      this.name = userid;
      this.password = pwd;
    }
  },
  methods: {
    ...mapMutations(['user/SET_TOKEN', 'header/SET_INSTALL']),
    ...mapActions(['user/login']),
    handleLogin() {
      const params = {
        userid: this.name,
        pwd: this.password,
        authedkey: 'web',
        call_time: new Date().getTime(),
      };
      this['user/login'](params);
    }
  },
};
</script>


<style scoped>
.login {
  height: 100%;
  position: relative;
}

form {
  display: flex;
  height: 80%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.from-item {
  line-height: 50px;
}

.from-item .span {
  display: inline-block;
  width: 200px;
}

.footer {
  position: absolute;
  bottom: 22px;
  right: 22px;
  font-size: 12px;
}

.footer img {
  vertical-align: middle;
  margin-right: 8px;
  width: 30px;
}

.record {
  margin-top: 20px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #3387f1;
  color: #fff;
  width: 55%;
  cursor: pointer;
}
</style>
